module.exports = __webpack_public_path__ + "static/media/una.269651cb.svg";